import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'

import { IFolderModel } from 'models/folder.model'

export const FOLDERS_ADMINISTRATION_LIST = 'FOLDERS_ADMINISTRATION_LIST'
export const FOLDERS_ADMINISTRATION_LIST_SUCCESS =
  'FOLDERS_ADMINISTRATION_LIST_SUCCESS'
export const DESTROY_FOLDER = 'DESTROY_FOLDER'
export const CREATE_FOLDER = 'CREATE_FOLDER'
export const UPDATE_FOLDER = 'UPDATE_FOLDER'
export const UPDATE_FOLDER_SUCCESS = 'UPDATE_FOLDER_SUCCESS'
export const ASSIGN_COURSE = 'ASSIGN_COURSE'
export const ORDER_FOLDER = 'ORDER_FOLDER'
export const LOADING_FOLDER = 'LOADING_FOLDER'
export const SORT_CONFIGURATION_FOLDER = 'SORT_CONFIGURATION_FOLDER'

export const Actions = {
  foldersAdministrationListSuccess: (data: IFolderModel[]) =>
    createAction(FOLDERS_ADMINISTRATION_LIST_SUCCESS, { data }),
  destroyFolder: (folderId: number) => createAction(DESTROY_FOLDER, folderId),
  createFolder: (data: IFolderModel) => createAction(CREATE_FOLDER, data),
  updateFolder: (data: IFolderModel, folderId: number) =>
    createAction(UPDATE_FOLDER, { data, folderId }),
  updateFolderSuccess: (data: IFolderModel) =>
    createAction(UPDATE_FOLDER_SUCCESS, { data }),
  assignCourse: (folderId: number, courseId: number) =>
    createAction(ASSIGN_COURSE, { folderId, courseId }),
  orderFolder: (folderId: number, targetId: number) =>
    createAction(ORDER_FOLDER, { folderId, targetId }),
  setLoading: (state: boolean) => createAction(LOADING_FOLDER, state),
}

export type Actions = ActionsUnion<typeof Actions>
